import { ISubscribeFlowRoute } from "@modules/Subscriptions/Flows/Subscribe/Subscribe";

export type ISteps =
  | "CHOOSE_FORMULA"
  | ISubscribeFlowRoute
  | "CONFIGURE_PAYMENT_METHOD";

export const ServiceAssignmentEventStep: {
  [key in ISteps]: string;
} = {
  CHECK_ORDER: "check_order",
  CHOOSE_FORMULA: "choose_formula",
  CHOOSE_PLAN: "choose_subscription_payment_plan",
  CHOOSE_PAYMENT_METHOD: "choose_preferred_payment_method",
  CONFIGURE_PAYMENT: "configure_payment",
  CONFIGURE_PAYMENT_METHOD: "configure_preferred_payment_method",
};
